import React from "react";
import styled from "styled-components";

import { ReactComponent as MuteSVG } from "assets/player/mute.svg";
import { ReactComponent as VolumeSVG } from "assets/player/volume.svg";
import { Button } from "../Button";
import { useRef } from "react";

const Container = styled.div`
  position: relative;
  display: grid;
  border-radius: 50px;
  height: 8px;
  max-width: 100px;
  overflow: hidden;

::before {
    content: '';
    position: absolute;
    border-radius: 50px;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
    background-color: #979797;
  }

  ::after {
    content: '';
    position: absolute;
    border-radius: 3px;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #7F39FA;
    width: ${({$percent}) => $percent};
    pointer-events: none;
  }
`

const Range = styled.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-progress-appearance: none;
  appearance: none;

  background-color: transparent;
  cursor: pointer;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    border: none;
    height: 0;
    width: 0;
  }
  
  &::-moz-range-thumb {
    -moz-appearance: none;
    appearance: none;
    border: none;
    height: 0;
    width: 0;
  }
  
  &::-ms-thumb {
    -ms-progress-appearance: none;
    appearance: none;
    border: none;
    height: 0;
    width: 0;
  }
`

const Volume = ({ value, onChange, onMute }) => {

  const isMuted = value === 0
  const percent = value * 100

  const handleChange = (e) => onChange(parseFloat(e.target.value))

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px'}}>
      <Button onClick={onMute}>
        {isMuted
          ? <MuteSVG width={25} height={22} />
          : <VolumeSVG width={25} height={25} />
        }
      </Button>

      <Container $percent={`${percent}%`}>
        <Range
          onChange={handleChange}
          type='range'
          min='0'
          max='1'
          step='0.01'
          value={`${value}`}
        />
      </Container>
    </div>
  );
};

export default Volume;
